import { useTranslation } from "react-i18next";

const Header = () => {
  const { t, i18n } = useTranslation();
  return (
    <div className="flex w-full flex-row items-center justify-center">
      <h1 className="text-[15px] font-semibold leading-7 text-white">
        {t("title.budget").toLocaleUpperCase(i18n.language)}
      </h1>
    </div>
  );
};

export default Header;
